module.exports = __webpack_public_path__ + "media/static/icons/icon-chevron-left--white-d3750da5586d2fc8a2e86f9d51e62c48.svg";